import { createAction } from 'deox';

import { ResponseError } from 'modules/errors';

import { LoginRequestBody, LoginResponse, UpdateTokensResponse } from 'types';

export const login = {
  request: createAction('user/LOGIN', (resolve) => (payload: LoginRequestBody) => resolve(payload)),
  success: createAction('user/LOGIN_SUCCESS', (resolve) => (payload: LoginResponse) =>
    resolve(payload),
  ),
  fail: createAction('user/LOGIN_FAIL', (resolve) => (error: ResponseError) => resolve(error)),
};

export const updateTokens = createAction(
  'user/UPDATE_TOKENS',
  (resolve) => (payload: UpdateTokensResponse) => resolve(payload),
);

export const logout = createAction('user/LOGOUT', (resolve) => () => resolve());
